export const EVENT_CALENDAR_VIEW = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  AGENDA: 'agenda',
} as const;

export type EventCalendarView =
  (typeof EVENT_CALENDAR_VIEW)[keyof typeof EVENT_CALENDAR_VIEW];

/** Desktop react-big-calendar toolbar views (excludes work_week). */
export const DESKTOP_EVENT_CALENDAR_VIEWS: Array<EventCalendarView> = [
  EVENT_CALENDAR_VIEW.MONTH,
  EVENT_CALENDAR_VIEW.WEEK,
  EVENT_CALENDAR_VIEW.DAY,
  EVENT_CALENDAR_VIEW.AGENDA,
];

export interface EventCalendarItem {
  title: string;
  start: Date;
  end: Date;
  resourceId: string;
  color: string;
  days: Array<string>;
}

export interface EventCalendarDaySection {
  day: Date;
  events: Array<EventCalendarItem>;
}

export interface EventCalendarRange {
  start: Date;
  end: Date;
}

export interface MobileEventCalendarProps {
  view: EventCalendarView;
  date: Date;
  events: Array<EventCalendarItem>;
  onViewChange: (view: EventCalendarView) => void;
  onDateChange: (date: Date) => void;
}
